module.exports = __webpack_public_path__ + "static/media/MinesBanner.3e179800.png";